import { createRoute } from '@tanstack/react-router'
import { authLayoutRoute } from 'src/layouts/routes'
import { z } from 'zod'

import { ServerErrorPage } from '..'

export const route500 = createRoute({
  getParentRoute: () => authLayoutRoute,
  component: () => <ServerErrorPage />,
  path: '/500',
  validateSearch: (search) =>
    z
      .object({
        redirectTo: z.string().optional()
      })
      .parse(search)
})
